<template>
  <div class="status" :class="StateTexteBG">
    {{ StateTexte }}
  </div>
</template>

<script>
import { rcPlusStateColorText } from "@/utils/Utils.js";

export default {
  props: {
    config: Object
  },
  computed: {
    StateTexte() {
      let LastPing = this.config?.rcPlus?.status?.LastPing != null
        ? parseInt(this.config.rcPlus.status.LastPing)
        : 99999999;

      if (LastPing > ENV.DEVICE_OFFLINE) {
        return "Hors ligne";
      }
      return "En ligne";
    },

    StateTexteBG() {
      let LastPing = this.config?.rcPlus?.status?.LastPing != undefined
        ? parseInt(this.config?.rcPlus?.status.LastPing)
        : 99999999;

      return "text-" + rcPlusStateColorText(LastPing);
    },
  },
};
</script>
